import React from "react";
import DataTable from "../../table/DataTable";

const Step3BulkConfirm = ({ selectedReceivers }) => {
  const columns = [
    {
      label: "Account name/Receiver",
      key: "name",
      render: (item) => <span className="fs-13 text-black">{item.name}</span>,
    },
    { label: "Country", key: "country", render: (item) => <span className="fs-13 text-black">{item.country}</span> },
    { label: "Bank/Agent", key: "bank", render: (item) => <span className="fs-13 text-black">{item.bank}</span> },
    { label: "Acc no/IBAN", key: "accNo", render: (item) => <span className="fs-13 text-black">{item.accNo}</span> },
    { label: "Receiving amount", key: "receivingAmount", render: (item) => <span className="fs-13 text-black">{item.receivingAmount}</span> },
    { label: "Send amount", key: "sendAmount", render: (item) => <span className="fs-13 text-black">{item.sendAmount}</span> },
    { label: "Fee", key: "fee", render: (item) => <span className="fs-13 text-black">{item.fee}</span> },
  ];

  const mockData = [
    {
      name: "SparkMinds check duplicate name",
      country: "Philippines",
      bank: "BDO",
      accNo: "0552000003601",
      receivingAmount: "801.89 PHP",
      sendAmount: "22 SGD",
      fee: "6 SGD",
    },
    {
      name: "BCA cash pickup",
      country: "Indonesia",
      bank: "BCA bank branches Indonesia",
      accNo: "-",
      receivingAmount: "258,258 IDR",
      sendAmount: "22 SGD",
      fee: "0 SGD",
    },
  ];

  const data = selectedReceivers && selectedReceivers.length > 0 ? selectedReceivers.map((r) => ({
    name: r.name,
    country: "Malaysia", // Mock if country isn't in original dataset
    bank: r.bank || "--",
    accNo: r.contactNo || "--", 
    receivingAmount: `${r.receivingAmount || 0} ${r.receivingCurrency || ""}`,
    sendAmount: `${r.sendAmount || 0} ${r.sendCurrency || ""}`,
    fee: `${r.fee || 0} ${r.sendCurrency || ""}`
  })) : mockData;

  const totalSendAmount = selectedReceivers.reduce((sum, r) => sum + parseFloat(r.sendAmount || 0), 0);
  const totalFee = selectedReceivers.reduce((sum, r) => sum + parseFloat(r.fee || 0), 0);
  const mainSendCurrency = selectedReceivers.length > 0 ? selectedReceivers[0].sendCurrency || "SGD" : "SGD";

  const receivingCurrenciesMap = selectedReceivers.reduce((acc, r) => {
    const currency = r.receivingCurrency || "MYR";
    acc[currency] = (acc[currency] || 0) + parseFloat(r.receivingAmount || 0);
    return acc;
  }, {});

  const summaryCurrencies =
    selectedReceivers.length > 0
      ? Object.keys(receivingCurrenciesMap).map((key) => ({
          currency: key,
          value: receivingCurrenciesMap[key].toFixed(2),
        }))
      : [
          { currency: "PHP", value: "801.89" },
          { currency: "IDR", value: "258,258" },
        ];

  const totalToPay = totalSendAmount + totalFee;
  const displaySendAmount = selectedReceivers.length > 0 ? `${totalSendAmount} ${mainSendCurrency}` : "44 SGD";
  const displayFee = selectedReceivers.length > 0 ? `${totalFee} ${mainSendCurrency}` : "0 SGD";
  const displayTotal = selectedReceivers.length > 0 ? `${totalToPay} ${mainSendCurrency}` : "44 SGD";

  return (
    <div className="mt-2 text-black">
      {/* Table Section */}
      <div
        className="card shadow-none rounded-3 mb-4 border-0"
        style={{ backgroundColor: "#fafafa" }}
      >
        <div className="card-body p-0 overflow-hidden">
          <DataTable
            columns={columns}
            data={data}
            showPagination={false}
            minWidth="100%"
            headerClassName="bg-light fw-bold text-black"
          />
        </div>
      </div>

      {/* Summary Section */}
      <div className="mt-4">
        <h6 className="fw-bold text-black mb-3 fs-14">Receiving amount</h6>
        <div className="card shadow-sm border-0 rounded-3 bg-white">
          <div className="card-body p-4">
            <div className="d-flex flex-column gap-3">
              {summaryCurrencies.map((item, idx) => (
                <div key={idx} className="d-flex justify-content-between">
                  <span className="text-muted fs-14">{item.currency}</span>
                  <span className="text-black fs-14">{item.value}</span>
                </div>
              ))}
            </div>

            <hr className="my-3 border-light opacity-50" />

            <div className="d-flex flex-column gap-3">
              <div className="d-flex justify-content-between">
                <span className="text-muted fs-14">Send amount</span>
                <span className="text-black fs-14">{displaySendAmount}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span className="text-muted fs-14">Fee</span>
                <span className="text-black fs-14">{displayFee}</span>
              </div>
            </div>

            <hr className="my-3 border-light opacity-50" />

            <div className="d-flex justify-content-between align-items-center">
              <span className="text-muted fs-14">Total to pay</span>
              <span className="text-black fw-bold fs-14">{displayTotal}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step3BulkConfirm;
